if (!customElements.get('rivh-size-finder')) {
  customElements.define('rivh-size-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      const result = this.querySelector('[role="status"]');
      const sizes = JSON.parse(this.querySelector('script').textContent);
      const calculate = () => {
        const raw = input.value.trim().replace(',', '.');
        const wrist = Number(raw);
        if (!/^\d{1,2}(\.\d{1,2})?$/.test(raw) || wrist < 8 || wrist > 35) {
          input.setAttribute('aria-invalid', 'true');
          result.textContent = this.dataset.invalid;
          return;
        }
        input.removeAttribute('aria-invalid');
        const matches = sizes.map(s => {
          const m = s.label.trim().match(/^(\d+(?:[.,]\d+)?)\s*cm$/i);
          return {...s, cm: m ? Number(m[1].replace(',', '.')) : NaN};
        }).filter(s => s.available && s.cm >= wrist + 0.5 - 0.001 && s.cm <= wrist + 1 + 0.001).sort((a,b) => a.cm-b.cm);
        result.textContent = matches.length ? this.dataset.result.replace('{size}', matches[0].label) : this.dataset.none;
      };
      this.querySelector('button').addEventListener('click', calculate);
      input.addEventListener('keydown', e => {if(e.key==='Enter'){e.preventDefault();calculate();}});
      input.addEventListener('input', () => {result.textContent='';input.removeAttribute('aria-invalid');});
    }
  });
}